import React from 'react';

export const PlansGridSkeleton = () => (
  <div className="billing-plans-grid billing-skeleton-grid" aria-label="Loading plans">
    {Array.from({ length: 3 }).map((_, idx) => (
      <div key={idx} className="billing-skeleton-card" />
    ))}
  </div>
);

export const SubscriptionCardSkeleton = () => (
  <div className="card billing-summary billing-skeleton-card" aria-label="Loading subscription" />
);

export const UsageSummarySkeleton = () => (
  <div className="card billing-summary billing-skeleton-card" aria-label="Loading usage" />
);

export const BillingTableSkeleton = () => (
  <div className="billing-table-skeleton" aria-label="Loading billing history">
    {Array.from({ length: 5 }).map((_, idx) => (
      <div key={idx} className="billing-skeleton-row" />
    ))}
  </div>
);

